export default {
  pageTitle: '会社概要',
  metaDescription: '2019年設立、日本のTOKKI LTDが出資するインドネシアの圧力容器・熱交換器メーカー、PT Tokki Engineering and Fabrication(TEF)についてご紹介します。',
  hero: { title: '会社概要' },
  companyInfo: {
    dateEstablished: '設立年月日',
    capital: '資本金',
    shareholder: '株主',
    presidentDirector: '代表取締役社長',
    totalEmployee: '従業員数',
    bank: '取引銀行',
    emailAddress: 'メールアドレス',
  },
  overview: {
    toggleLabel: '会社概要',
    paragraph1:
      '2019年に設立されたPT Tokki Engineering and Fabrication（TEF）は、TOKKI LTD.の子会社であり、世界中の顧客に高品質な製作品を競争力のある価格で提供するために設立されました。インドネシアを拠点とするTEFは、<b>溶接圧力容器および板金部品</b>の製作を専門とし、<b>石油・ガス、石油化学、製薬、肥料、発電、熱処理産業</b>など、さまざまな産業分野に対応しています。',
    paragraph2:
      '<strong>エンジニアリングの卓越性、コンサルティングの専門知識、高度な溶接技術、そして特殊材料の取り扱い</strong>への強いコミットメントにより、TEFは業界の絶え間なく進化する要求に応えるため、革新を続けています。',
  },
  specialization: {
    toggleLabel: '当社の専門分野',
    paragraph:
      'TEFは<b>ステンレス鋼、ニッケル基合金、チタン、その他の特殊材料</b>を用いた製品製作において豊富な経験を有しています。私たちの専門知識が耐久性、精度、そして国際基準への準拠を保証します。',
  },
  values: {
    toggleLabel: '私たちの価値観',
    item1: {
      title: '1. ワンストップのエンジニアリング・製作サービス',
      desc: '設計コンサルティングから製作、検査、納品に至るまで、完全に統合されたソリューションを提供し、各段階における効率性、連携、そして品質を確保します。TEFは、当社の工場だけでなく、お客様の現場に直接出向いての修繕やサービス作業も行うことができます。',
    },
    item2: {
      title: '2. 特殊材料・高性能材料に関する専門知識',
      desc: 'ステンレス鋼、ニッケル合金、チタン、その他の特殊材料に関する豊富な経験により、重要なプロセス産業向けに耐久性と高性能を備えた製品を提供することができます。',
    },
    item3: {
      title: '3. 認証された品質とエンジニアリング精度',
      desc: 'ISO 9001:2015やASME U・Rスタンプなどの国際認証に裏付けられ、当社のプロセスは精度、信頼性、そしてグローバル基準への厳格な準拠を実現するよう設計されています。',
    },
    item4: {
      title: '4. コスト効率に優れた長期的ソリューション',
      desc: '私たちはプロセス産業におけるメンテナンスコストを最小限に抑えるソリューションプロバイダーを目指しています。長期的なメンテナンスの必要性を軽減し、運用の安定性を高めるスマートな製作ソリューションを提供することで、戦略的パートナーとなることを目指します。',
    },
    item5: {
      title: '5. 信頼できる納品によるお客様満足の実現',
      desc: '私たちのコミットメントは明確です：高品質な製品を、時間通りに、競争力のある価格で提供し、すべてのお客様に一貫した価値と信頼できるサポートをお届けします。',
    },
  },
  visionMission: {
    heading: 'ビジョン＆ミッション',
    vision: {
      title: 'ビジョン',
      item1: '私たちはMastery Meets Innovationを結集し、腐食問題やその他のプロセス産業の課題を一か所で解決します。',
      item2: '私たちは、誰もが安心できる、信頼される総合的な業界トップの製作会社を目指します。',
    },
    mission: {
      title: 'ミッション',
      item1: '私たちは、卓越した技術、革新、挑戦への情熱、そして誠実さをもって、プロセス産業における強い信頼関係を築き、新たな可能性を創造します。',
      item2:
        '私たちは、匠の技と先進技術を融合させ、高品質な製品とサービスを提供します。お客様の安定した操業と安心を確保しながら、そのビジネスに継続的に新たな価値をもたらすことを目指します。',
      item3: '私たちは情熱をもって課題に挑み、変化を推進します。それにより、プロセス産業に刺激を与え、持続的な成長と革新につながる魅力的な未来を築きます。',
    },
  },
  qualityPolicy: {
    heading: '品質方針',
    commitmentTitle: '継続的改善への取り組み',
    commitmentDesc:
      '私たちは、お客様満足度の向上と<br>業務の卓越性を実現するため、品質マネジメントシステムの継続的な改善に取り組んでいます。',
    ourCommitmentsHeading: '私たちの約束：',
    commitment1: '1. 品質目標を達成するためのチームワークを育みます。',
    commitment2: '2. 以下を提供することでお客様中心のアプローチを実践します：',
    deliverList: {
      item1: '高品質で信頼性の高い製品',
      item2: '納期厳守の納品',
      item3: '誠実に設計された高い価値と適正な価格',
      item4: '迅速な技術・営業サービス',
    },
    accountabilityHeading: '説明責任とコンプライアンス：',
    accountabilityList: {
      item1: 'ISO 9001:2015、関連法規、および利害関係者の期待への準拠を徹底します。',
      item2: '品質保証担当者が制約なく品質問題に対応できるよう権限を与えます。',
      item3: '全従業員が品質基準の維持・向上に関与します。',
    },
    structureHeading: '体系的な仕組みと責任：',
    structureList: {
      item1: '包括的な品質マニュアルが当社の品質管理の指針となっています。',
      item2: '全従業員は品質手順を遵守し、効果的な連携を通じて貢献しなければなりません。',
      item3: '新入社員は体系的な研修を受けます。',
      item4: '課長は安全および品質管理の実践が確実に理解・実施されるようにします。',
    },
  },
  parentCompany: {
    heading: '親会社',
    desc1: 'PT. Tokki Engineering and Fabricationの親会社はTokki Co,. Ltdです。',
    desc2: 'Tokki Co,. Ltdの会社概要および事業内容につきましては、以下のウェブサイトをご覧ください：',
  },
};
